import { render, staticRenderFns } from "./VesselDropdown.vue?vue&type=template&id=6d38d1c2&scoped=true&"
import script from "./VesselDropdown.vue?vue&type=script&lang=js&"
export * from "./VesselDropdown.vue?vue&type=script&lang=js&"
import style0 from "./VesselDropdown.vue?vue&type=style&index=0&id=6d38d1c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d38d1c2",
  null
  
)

export default component.exports